const TermsOfUsePage = () => {
  return (
    <div className="legal-page">
      <h1>Terms of Use</h1>
    </div>
  );
};

export default TermsOfUsePage;
